import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Modal, Button } from 'react-bootstrap';

import FloatingInput from 'components/elements/atoms/FloatingInput/FloatingInput';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import * as Actions from '../../../redux/actions/index';
import { Icon, ICONS } from '../../Icons';

import './ManageCourse.scss';
import { FocusTrap } from 'focus-trap-react';

function ManageCourse({ onClose, actions, course = {} }) {
  const [name, setName] = useState(course.name || '');
  const [startDate, setStartDate] = useState(
    () => course.startDate || new Date().toISOString().split('T')[0],
  );
  const [endDate, setEndDate] = useState(() => course.endDate || '');
  const [error, setError] = useState('');

  useEffect(() => {
    if (error) {
      setError('');
    }
    // eslint-disable-next-line
  }, [name]);

  const createCourse = () => {
    if (!course.name) {
      actions
        .createCourse(name, startDate, endDate)
        .then(() => onClose())
        .catch((error) => {
          setError(
            error.message ||
              'Error occurred while adding course. Please try again.',
          );
        });
    } else {
      actions
        .updateCourse({
          courseId: course.courseId,
          name,
          startDate: startDate || null,
          endDate: endDate || null,
          isFavorite: course.isFavorite,
        })
        .then(() => onClose())
        .catch((error) => {
          setError(
            error.message ||
              'Error occurred while adding course. Please try again.',
          );
        });
    }
  };

  return (
    <Modal show={true} className="manage-course-modal">
      <FocusTrap>
        <div>
          <Modal.Body>
            <div className="header mb-4">
              <span>{!course.name ? 'Create' : 'Update'} Course</span>
              <Button bsStyle="link" className="btn-close" onClick={onClose}>
                <Icon icon={ICONS.CLOSE} className="mr-0" />
              </Button>
            </div>
            <FloatingInput
              autoFocus={true}
              value={name}
              labelName="Course Name"
              onChange={(e) => setName(e.target.value)}
              error={error || ''}
              required
            />
            <div className="mb-5">
              <FloatingInput
                value={startDate ? moment(startDate).format('YYYY-MM-DD') : ' '}
                type="date"
                labelName="Start Date"
                onChange={(e) => setStartDate(e.target.value)}
                min={course.startDate ? moment().format('YYYY-MM-DD') : null}
                max={endDate ? moment(endDate).format('YYYY-MM-DD') : ' '}
                onFocus={(e) => {
                  try {
                    e.target.showPicker();
                  } catch {}
                }}
                onClick={(e) => {
                  try {
                    e.target.showPicker();
                  } catch {}
                }}
                required
              />
            </div>
            <div className="mb-5">
              <FloatingInput
                value={endDate ? moment(endDate).format('YYYY-MM-DD') : ' '}
                type="date"
                labelName="End Date"
                onChange={(e) => setEndDate(e.target.value)}
                min={
                  startDate
                    ? moment(startDate).format('YYYY-MM-DD')
                    : course.endDate
                    ? moment().format('YYYY-MM-DD')
                    : null
                }
                onFocus={(e) => {
                  try {
                    e.target.showPicker();
                  } catch {}
                }}
                onClick={(e) => {
                  try {
                    e.target.showPicker();
                  } catch {}
                }}
                required
              />
            </div>
            <RectangularButton
              className="next-button"
              disabled={!name || !startDate || !endDate}
              onClick={() => createCourse()}
            >
              Submit
            </RectangularButton>
          </Modal.Body>
        </div>
      </FocusTrap>
    </Modal>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(ManageCourse);
